  export const setMemberInBodyTests = (value) => {
    return {
      type: "SET_MEMBER_IN_BODY_TESTS",
      payload: { data: value },
    };
  };
  export const setMemberInBodyTestsCount = (value) => {
    return {
      type: "SET_MEMBER_IN_BODY_TESTS_COUNT",
      payload: { data: value },
    };
  };
  export const addInBodyTestModalAction = (value) => {
  return {
    type: "ADD_IN_BODY_TEST_MODAL",
    payload: { data: value },
  };
};